
<script>
	import { onMount } from "svelte";
	import * as THREE from 'three';

import { TTFLoader } from 'three/examples/jsm/loaders/TTFLoader.js';
import { AsciiEffect } from 'three/examples/jsm/effects/AsciiEffect.js';

let container, viewer, loading;
			let camera, cameraTarget, scene, renderer, effect;
			let group, textMesh1, textMesh2, textGeo, material;
			let firstLetter = true;

			let text = 'loading';
			const height = 20,
				size = 70,
				hover = 30,
				curveSegments = 4,
				bevelThickness = 2,
				bevelSize = 1.5;

			let font = null;
			const mirror = true;

			let targetRotation = 0;
			let targetRotationOnPointerDown = 0;

			let pointerX = 0;
			let pointerXOnPointerDown = 0;

			let windowHalfX = window.innerWidth / 2;


			function init() {

				container = document.createElement( 'div' );
				document.body.appendChild( container );

				// CAMERA

				camera = new THREE.PerspectiveCamera( 30, window.innerWidth / window.innerHeight, 1, 1500 );
				camera.position.set( 0, 400, 700 );

				cameraTarget = new THREE.Vector3( 0, 150, 0 );

				// SCENE

				scene = new THREE.Scene();
				scene.background = new THREE.Color( 0x000000 );
				scene.fog = new THREE.Fog( 0x000000, 250, 1400 );

				// LIGHTS

				const dirLight = new THREE.DirectionalLight( 0xffffff, 0.125 );
				dirLight.position.set( 0, 0, 1 ).normalize();
				scene.add( dirLight );

				const pointLight = new THREE.PointLight( 0xffffff, 1.5 );
				pointLight.position.set( 0, 100, 90 );
				pointLight.color.setHSL( Math.random(), 1, 0.5 );
				scene.add( pointLight );

				material = new THREE.MeshPhongMaterial( { color: 0xffffff, flatShading: true } );

				group = new THREE.Group();
				group.position.y = 100;

				scene.add( group );

				const loader = new TTFLoader();

				loader.load( 'fonts/Megrim.ttf', function ( json ) {

					font = new THREE.Font( json );
					createText();

				} );

				const plane = new THREE.Mesh(
					new THREE.PlaneGeometry( 10000, 10000 ),
					new THREE.MeshBasicMaterial( { color: 0xffffff, opacity: 0, transparent: true } )
				);
				plane.position.y = 100;
				plane.rotation.x = - Math.PI / 2;
				scene.add( plane );

				// RENDERER

				renderer = new THREE.WebGLRenderer( { antialias: true } );
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( window.innerWidth, window.innerHeight );

				effect = new AsciiEffect( renderer, ' abcdefghijklmnopqrstuvwxyz.:-+*=%@#', { invert: true } );
				effect.setSize( window.innerWidth, window.innerHeight );
				effect.domElement.style.color = 'white';
				effect.domElement.style.backgroundColor = 'black';

				// Special case: append effect.domElement, instead of renderer.domElement.
				// AsciiEffect creates a custom domElement (a div container) where the ASCII elements are placed.

				
				//controls = new TrackballControls( camera, effect.domElement );
				container.appendChild( effect.domElement );



				// EVENTS

				container.style.touchAction = 'none';
				container.addEventListener( 'pointerdown', onPointerDown );

				document.addEventListener( 'keypress', onDocumentKeyPress );
				document.addEventListener( 'keydown', onDocumentKeyDown );

				window.addEventListener( 'resize', onWindowResize );

			}

			function onWindowResize() {

				windowHalfX = window.innerWidth / 2;

				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();

				renderer.setSize( window.innerWidth, window.innerHeight );
				effect.setSize( window.innerWidth, window.innerHeight );

			}

			function onDocumentKeyDown( event ) {

				if ( firstLetter ) {

					firstLetter = false;
					text = '';

				}

				const keyCode = event.keyCode;

				// backspace

				if ( keyCode === 8 ) {

					event.preventDefault();

					text = text.substring( 0, text.length - 1 );
					refreshText();

					return false;

				}

			}

			function onDocumentKeyPress( event ) {

				const keyCode = event.which;

				// backspace

				if ( keyCode === 8 ) {

					event.preventDefault();

				} else {

					const ch = String.fromCharCode( keyCode );
					text += ch;

					refreshText();

				}

			}

			function createText() {

				textGeo = new THREE.TextGeometry( viewer.hic_et_nunc_holder[0]?.name?.toUpperCase(), {

					font: font,

					size: size,
					height: height,
					curveSegments: curveSegments,

					bevelThickness: bevelThickness,
					bevelSize: bevelSize,
					bevelEnabled: true

				} );

				textGeo.computeBoundingBox();
				textGeo.computeVertexNormals();

				const centerOffset = - 0.5 * ( textGeo.boundingBox.max.x - textGeo.boundingBox.min.x );

				textMesh1 = new THREE.Mesh( textGeo, material );

				textMesh1.position.x = centerOffset;
				textMesh1.position.y = hover;
				textMesh1.position.z = 0;

				textMesh1.rotation.x = 0;
				textMesh1.rotation.y = Math.PI * 2;

				group.add( textMesh1 );

				if ( mirror ) {

					textMesh2 = new THREE.Mesh( textGeo, material );

					textMesh2.position.x = centerOffset;
					textMesh2.position.y = - hover;
					textMesh2.position.z = height;

					textMesh2.rotation.x = Math.PI;
					textMesh2.rotation.y = Math.PI * 2;

					group.add( textMesh2 );

				}

			}

			function refreshText() {

				group.remove( textMesh1 );
				if ( mirror ) group.remove( textMesh2 );

				if ( ! text ) return;

				createText();

			}

			function onPointerDown( event ) {

				if ( event.isPrimary === false ) return;

				pointerXOnPointerDown = event.clientX - windowHalfX;
				targetRotationOnPointerDown = targetRotation;

				document.addEventListener( 'pointermove', onPointerMove );
				document.addEventListener( 'pointerup', onPointerUp );

			}

			function onPointerMove( event ) {

				if ( event.isPrimary === false ) return;

				pointerX = event.clientX - windowHalfX;

				targetRotation = targetRotationOnPointerDown + ( pointerX - pointerXOnPointerDown ) * 0.02;

			}

			function onPointerUp() {

				if ( event.isPrimary === false ) return;

				document.removeEventListener( 'pointermove', onPointerMove );
				document.removeEventListener( 'pointerup', onPointerUp );

			}

			//

			function animate() {

				requestAnimationFrame( animate );

				group.rotation.y += ( targetRotation - group.rotation.y ) * 0.05;

				camera.lookAt( cameraTarget );

				//renderer.render( scene, camera );
				effect.render( scene, camera );

			}

			

const getWalletMetaData = async (viewer) => {
	let _address = new URLSearchParams(window.location.search).get("viewer") ||
      "tz2NHCNf862d1j9pfEk37vRRwv8tMCE2hJFv";
	let query = `
		query GetName {
			hic_et_nunc_holder(where: {address: {_eq: "${_address}"}}) {
				address
				name
			}
			}
	`;
    const wallet = await doFetch(query);
  
    console.log("viewer", wallet);
	return wallet;
  };

  

  async function fetchGraphQL(operationsDoc, operationName, variables) {
    loading = true;
    const result = await fetch("https://api.hicdex.com/v1/graphql", {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName,
      }),
    });
    loading = false;
    return await result.json();
  }

  async function doFetch(query) {
	  console.log('query', query)
    const { errors, data } = await fetchGraphQL(query, "GetName", {});
    if (errors) {
      console.error(errors);
    }
    console.log('data',data);

    return data;
  }


onMount(async () => {
	viewer =
      new URLSearchParams(window.location.search).get("viewer") ||
      "tz2NHCNf862d1j9pfEk37vRRwv8tMCE2hJFv";

    viewer = await getWalletMetaData();
	init();
	animate();
});

</script>